import { LOCALE_TYPE } from 'src/types/locale';
import { getLocaleFromUrl } from 'src/utils/subdomain';

export const pickGaIdForBuild = (locale: LOCALE_TYPE): string => {
  if (process.env.NEXT_PUBLIC_WAMAZING_ENV !== 'production') {
    switch (locale) {
      case 'zh_tw':
        return 'G-BCLPY6MXSY';
      case 'zh_hk':
        return 'G-WS7SYVL1XK';
      case 'zh_cn':
        return 'G-BCLPY6MXSY';
      case 'en':
        return 'G-8XL80VSXR4';
    }
  }

  switch (locale) {
    case 'zh_tw':
      return 'G-1TGBY3ZLKX';
    case 'zh_hk':
      return 'G-B9KB0YNZZE';
    case 'zh_cn':
      return 'G-1TGBY3ZLKX';
    case 'en':
      return 'G-BG5Q2LFJEJ';
  }

  return 'G-BG5Q2LFJEJ'; // fallback
};

export const pageView = (url: string, id: string) => {
  if (getLocaleFromUrl() === LOCALE_TYPE.CN) return;
  window.gtag('config', id, {
    page_path: url,
  });
};

export const orderButtonClickedEvent = () => {
  if (getLocaleFromUrl() === LOCALE_TYPE.CN) return;
  window.gtag('event', 'kaimono_order_clicked', {});
};
